import actions from "./actions";

const initState = {
  listFollower: [],
  isLoading: false,
  currentFollower: {},
};

export default function followerReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_LIST_FOLLOWER:
      return {
        ...state,
        listFollower: action.payload,
        isLoading: false,
      };
    case actions.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case actions.SET_CURRENT_FOLLOWER:
      return {
        ...state,
        currentFollower: action.payload,
      };
    default:
      return state;
  }
}
